export default "__VITE_ASSET__KJ3QFQpj__"